module.exports = __webpack_public_path__ + "static/media/22ESCWA13.ad56be6e.jpg";